import { getMessages } from '../../../../../../../store/constants';

export const CARD_COLOR_TAGS_EDIT_TOOLTIP = getMessages().getText('card_form_color_tags_edit_tooltip');
